export default "__VITE_ASSET__BWi38BT6__"